import { Row } from 'antd';
import React from 'react';

interface ViewProps {
    children?: React.ReactNode;
    style?: React.CSSProperties;
}

export const Bullseye: React.FunctionComponent<ViewProps> = (props) => {
    const style = props.style || { minHeight: '100vh' };

    return (
        <Row justify="center" align="middle" style={style}>
            { props.children }
        </Row>
    );
};
